<template>
  <div>
    <h2>Edit School / College</h2>
    <div class="description">Edit school / college data, that show on web application</div>

    <v-form direction="horizontal" :model="form" :rules="rules" ref="formRef">
      <v-form-item label="School / College Name" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="name">
        <v-input size="large" v-model="form.name" placeholder="School / College Name"></v-input>
      </v-form-item>
      <v-form-item label="Province" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="province" style="position:relative">
        <v-input size="large" v-model="form.province" placeholder="Province"
          @keyup="provinceOptionsDisplay=true"></v-input>
        <ul class="typeahead-list" v-if="form.province && provinceOptionsDisplay && provincesText.indexOf(form.province.toLowerCase()) > -1">
          <li v-for="province in optionsProvince" :key="province.label" class="province-option"
            v-if="form.province && province.label.toLowerCase().indexOf(form.province.toLowerCase()) > -1">
            <a @click.prevent="() => selectProvince(province.label)" class="province-option">{{ province.label }}</a>
          </li>
        </ul>
      </v-form-item>
      <v-form-item label="Campus" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="campus">
        <v-input size="large" v-model="form.campus" placeholder="Campus"></v-input>
      </v-form-item>
      <v-form-item label="Country" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="country">
        <v-input size="large" v-model="form.country" placeholder="Country" disabled></v-input>
      </v-form-item>
      <v-form-item :wrapper-col="{offset:6, span: 14 }">
        <v-button type="primary" style="margin-right:10px" @click.prevent="updateForm('formRef')">Update</v-button>
        <v-button type="ghost" @click.prevent="resetForm('formRef')">Reset</v-button>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
import fb from '@/firebase'
import { mapGetters } from 'vuex'

export default {
  name: 'EditSchool',
  data () {
    return {
      optionsProvince: [],
      provincesText: '',
      provinceOptionsDisplay: false,
      form: {
        name: null,
        province: null,
        campus: null,
        display_status: true,
        country: 'Canada'
      },
      editedSchool: null,
      rules: {
        name: [{
          required: true,
          message: '* Required'
        }],
        province: [{
          required: true,
          message: '* Required'
        }],
        campus: [{
          required: true,
          message: '* Required'
        }]
      },
      displayOptions: [{
        value: 1,
        label: 'Show on web application'
      }, {
        value: 0,
        label: 'Hide on web application'
      }]
    }
  },
  created () {
    this.$store.dispatch('setLoaderStatus', true)
    fb.getSchool(this.$route.params.schoolId)
      .then((doc) => {
        this.form = doc.data()
        this.editedSchool = {...this.form}
        this.$store.dispatch('setLoaderStatus', false)
      })
    document.addEventListener('click', this.documentClick)
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick)
  },
  computed: {
    ...mapGetters([
      'lov'
    ])
  },
  watch: {
    lov: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getLov')
        } else {
          for (let key in val.provinces) {
            this.optionsProvince.push({
              label: key,
              value: key
            })
            this.provincesText += key.toLowerCase()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    selectChange (key, val) {
      this.form[key] = val
    },
    updateForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch('updateSchool', {id: this.$route.params.schoolId, payload: this.form})
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.form = {...this.editedSchool}
    },
    selectProvince (province) {
      this.form.province = province
      this.provinceOptionsDisplay = false
    },
    documentClick (ev) {
      if (ev.target.className === 'province-option') {
        this.provinceOptionsDisplay = true
      } else {
        this.provinceOptionsDisplay = false
      }
    }
  }
}
</script>

<style scoped>
h2 {
  margin-bottom: 8px;
}
.description {
  margin-bottom: 34px;
}
.typeahead-list {
   width: 100%;
   position: absolute;
   border: 1px solid rgb(233, 235, 236);
   z-index: 10;
   background-color: #fff;
   margin-top: 4px;
   min-height: 200px;
   max-height: 200px;
   overflow-y: auto;
}
.typeahead-list li {
  padding-left: 5px;
}
.typeahead-list li:hover {
background-color: rgba(57, 57, 57, .7);
}
.typeahead-list li:hover a, .typeahead-list li a:hover {
  color: rgb(233, 235, 236);
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Schools/EditSchool.vue